const refundsSettingsSection = "/refunds-settings";

export const refundsSettingsPath = refundsSettingsSection;
